import Container from "../components/Container";
import * as React from "react";
import { Header } from "../components/Page";

import JSONEditor from "../components/JSONEditor";
import { RouteComponentProps } from "react-router";

const EditProductQuestionary = ({
  match
}: RouteComponentProps<{ type: string }>) => {
  return (
    <Container>
      <Header selected={match.params.type as any} />
      <JSONEditor
        path={`templates/${match.params.type}`}
        key={match.params.type}
      />
    </Container>
  );
};

export default EditProductQuestionary;
